import { render, staticRenderFns } from "./SapBuffer.vue?vue&type=template&id=793238c3&"
import script from "./SapBuffer.vue?vue&type=script&lang=js&"
export * from "./SapBuffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports